<template>
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      class="blue"
      d="M24.4357 12.2667C24.4357 11.28 24.3557 10.56 24.1824 9.81335H12.9157V14.2666H19.529C19.3957 15.3733 18.6757 17.04 17.0757 18.1599L17.0533 18.309L20.6156 21.0687L20.8624 21.0934C23.129 19 24.4357 15.92 24.4357 12.2667Z"
      fill="none"
    />
    <path
      class="green"
      d="M12.9157 24C16.1557 24 18.8757 22.9333 20.8624 21.0934L17.0757 18.1599C16.0624 18.8666 14.7024 19.3599 12.9157 19.3599C9.74243 19.3599 7.04911 17.2667 6.08902 14.3734L5.94829 14.3853L2.24415 17.252L2.19571 17.3866C4.16902 21.3066 8.22237 24 12.9157 24Z"
      fill="none"
    />
    <path
      class="yellow"
      d="M6.08902 14.3733C5.83569 13.6267 5.68908 12.8266 5.68908 12C5.68908 11.1733 5.8357 10.3733 6.0757 9.62664L6.06898 9.46762L2.31842 6.5549L2.19571 6.61327C1.38241 8.23996 0.915741 10.0667 0.915741 12C0.915741 13.9333 1.38241 15.7599 2.19571 17.3866L6.08902 14.3733Z"
      fill="none"
    />
    <path
      class="red"
      d="M12.9157 4.63997C15.169 4.63997 16.689 5.6133 17.5557 6.42669L20.9424 3.12C18.8624 1.18667 16.1557 0 12.9157 0C8.22237 0 4.16902 2.69331 2.19571 6.61328L6.07569 9.62666C7.04911 6.73333 9.74243 4.63997 12.9157 4.63997Z"
      fill="none"
    />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "GoogleIcon",
});
</script>

<style scoped lang="scss">
@use "./google.scss";
</style>
